// extracted by mini-css-extract-plugin
module.exports = {"surveyPage":"styles-module__surveyPage___3Hs2q","surveySection":"styles-module__surveySection___17DPn","footer":"styles-module__footer___e8uk3"};